import React, { useEffect, useState } from 'react';
import { contractAddress } from "../../config/BackendUrl"; // Config file for contract address
import { listNFTs } from '../../hooks/NFTHook'; // API hook to fetch NFT data
import DynamicNFTCard from './DynamicCard'; // Component to display individual NFT cards
import CardPlaceholder from '../cards/NFTCardPlaceholder'; // Skeleton loader for NFT cards

function CardMarketplace(props) {
  // State variables
  const [nfts, setNfts] = useState([]); // Holds the fetched NFT data
  const [hasMore, setHasMore] = useState(true); // Determines if there are more NFTs to load
  const userIds = localStorage.getItem("userId"); // User ID from local storage
  const userWalletAddress = localStorage.getItem("WalletAddress"); // Wallet address from local storage

  // Fetch NFTs when the component mounts or when the contract address changes
  useEffect(() => {
    fetchNFTs();
  }, [props.filter]);

  /**
   * Fetch NFTs from the backend API
   * - Sort by `createdAt` to show the most recent NFTs
   * - Adds a `isLike` flag for NFTs liked by the logged-in user
   */
  console.log("filter at Card", props.filter);

  const fetchNFTs = async () => {
    try {
      let Params;
      if (props.filter === "latest") {
        Params = {
          page: 1,
          limit: 8,
          sortBy: "createdAt",
          contractAddress: contractAddress // Fetch NFTs for a specific contract address
        };
      }
      else {
        Params = {
          page: 1,
          limit: 8,
          sortBy: "createdAt",
          category: props.filter,
          contractAddress: contractAddress // Fetch NFTs for a specific contract address
        };
      }
      // const params = { page: 1, limit: 8, sortBy: "createdAt", contractAddress };
      const response = await listNFTs(Params); // Fetch NFTs using the API

      if (response && response.data) {
        const fetchedNFTs = response.data;

        // Add `isLike` flag to each NFT
        const processedNFTs = fetchedNFTs.map(item => {
          const isLike = item.likes.some(like => like.userId === userIds); // Check if the user has liked the NFT
          return { ...item, isLike };
        });

        setNfts(processedNFTs); // Update state with processed NFT data

        // Check if there are no more NFTs to load
        if (fetchedNFTs.length === 0) {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Error fetching NFTs:", error); // Log any errors
    }
  };

  return (
    <>
      <div className="row">
        {/* Render NFT cards if NFTs are available */}
        {nfts.length > 0 ? (
          nfts.map((nft, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6 card-hover-effect">
              <DynamicNFTCard
                NFTLink={`/nftdetails/${contractAddress}/${nft._id}`} // Dynamic link to NFT details
                contractAddress={nft.contractAddress}
                currentOwnerPic={nft?.currentOwner?.userId?.profilePicture} // Owner's profile picture
                currentOwnerName={nft?.currentOwner?.userId?.name} // Owner's name
                currentOwnerLink={
                  nft?.currentOwner?.walletAddress !== userWalletAddress
                    ? `/otherProfile/${nft?.currentOwner?.walletAddress}`
                    : "/profile"
                } // Owner's profile link
                mediaUrl={nft.imageUri} // URL of the media (image or video)
                assetType={nft.assetType} // Determines if the asset is an image or video
                title={nft.title} // Title of the NFT
                price={nft.price} // Price of the NFT
                likes={nft.totalLikes} // Total number of likes
                isLiked={nft.isLike} // Whether the NFT is liked by the user
                tokenId={nft.tokenId} // Token ID of the NFT
                isListed={nft.listed} // Whether the NFT is listed for sale
                nftId={nft._id} // Unique NFT ID
              />
            </div>
          ))
        ) : hasMore ? (
          // Show skeleton loaders while NFTs are being fetched
          [...Array(8)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <CardPlaceholder />
            </div>
          ))
        ) : (
          // Display a message when no NFTs are available
          <h3>No NFTs Available</h3>
        )}
      </div>
    </>
  );
}

export default CardMarketplace;
